import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import {
  RelatedList,
  RelatedListItem,
  RelatedSettings as RelatedSettingsContainer,
} from 'components/RelatedSettings'
import { DomainPrebidStack } from 'features/inventory/domain/types/domainPrebidStack'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'

type Props = Pick<DomainPrebidStack, 'prebidCustomConfig'>

export const CustomPrebidConfigRelatedSettings = ({
  prebidCustomConfig,
}: Props): React.JSX.Element => {
  const { t: tc } = useTranslation('common', {
    keyPrefix: 'definedState',
  })
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.prebidStack.advancedPrebidSettings',
  })

  const { workspaceId } = useWorkspaceParam()

  return (
    <RelatedSettingsContainer title={t('customPrebidConfigRelatedSettings.title')}>
      <RelatedList>
        <RelatedListItem
          content={t('customPrebidConfigRelatedSettings.prebidCustomConfig', {
            value: tc(_.isEmpty(JSON.parse(prebidCustomConfig)) ? 'false' : 'true'),
          })}
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            tab: 'prebid-stack',
            workspaceId,
          })}
        />
      </RelatedList>
    </RelatedSettingsContainer>
  )
}
